<template>
    <div class="wrap">
        <!-- <iframe src="iframesrc" frameborder="0" style="width:100%;height:100%;border:0;min-width: 1400px;"></iframe> -->
        <CHeader :hideMenu="hideMenu" />
        <iframe :src="iframesrc" frameborder="0" style="width:100%;height:100%;border:0;min-width: 1400px;"></iframe>
    </div>
</template>

<script>
import CHeader from "../exhibition/components/Headers";
import { mapState } from "vuex";

export default {
    data() {
        return {
            iframesrc: '',
            hideMenu: false,
        }
    },
    computed: {
        ...mapState(["userInfo","language"]),
    },
    mounted() {
        this.iframesrc = 'https://720.cloudvhall.com/shidai/islandNongye'
    },
    methods:{
        
    },
    components: {
        CHeader,
    },

}
</script>

<style lang="scss" scoped>
.wrap{
    min-width: 1400px;
    width: 100%; 
    height: 100vh;
    background-size: 100% 100%;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/islandAgricultural/index.vue